import { useContext } from "react";
import AuthStatus from "../AuthStatus/AuthStatus";
import "./style.scss";
import RegistrationContext from "../../contexts/RegistrationContext";

const NavBar2 = () => {
  const { loading } = useContext(RegistrationContext);

  return <div className="navbar">{!loading && <AuthStatus />}</div>;
};

const NavBar = ({ boxed }) => {
  const { loading, authenticated, isSoldout, screen } = useContext(RegistrationContext);
  const isAdminScreen = typeof screen === "string" && screen.startsWith("admin-");

  return (
    <>
      <div className={`navbar ${boxed ? "boxed" : ""} ${isAdminScreen ? "navbar--admin" : ""}`}>
        {!loading && <AuthStatus />}
      </div>
      {authenticated && (screen !== "Confirmation") && (
        <>
          {isSoldout ? (
            <div
              className={`flex flex-col justify-center bg-red-200 ${
                boxed ? "message_box" : "hidden"
              } `}
            >
              <div
                className=" flex justify-center  rounded-lg flex-col lg:flex-row  text-center  "
                style={{
                  margin: "auto",
                  padding: "10px 2em",
                  color: "#20334d",
                }}
              >
                Due to the unprecedented success of ECAI 2024, and to  ensure delegate comfort and safety.
                The registration application is closed to new registrations.
              </div>
            </div>
          ): (
            <div
              className={`flex flex-col justify-center bg-yellow-200 ${
                boxed ? "message_box" : "hidden"
              } `}
            >
              <div
                className=" flex justify-center  rounded-lg flex-col lg:flex-row  text-center  "
                style={{
                  margin: "auto",
                  padding: "10px 2em",
                  color: "#20334d",
                }}
              >
                <div>
                Due to the unprecedented success of ECAI 2024, registrations are nearing the maximum limit to ensure delegate comfort and safety.
With this priority in mind:
<ul className="list-disc list-inside mt-3">
<li><b>No in-person registrations will be allowed.</b> Delegates wishing to attend ECAI 2024 must register in advance using the registration application.</li>
<li>Once the maximum limit is reached, the registration application will be closed to new registrations.</li>
</ul>
</div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default NavBar;
